import React, { Component } from "react";

import { withStyles } from '@mui/styles';
import styles from './index.styles';
import { withTranslation } from 'react-i18next';
import { Table, TableBody, TableCell, TableHead, TableRow, Tooltip, TableSortLabel, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Card, CardContent, Typography, Grid } from "@mui/material";
import { Box } from "@mui/system";
import spinner from './images/spinner.gif';
import InfiniteScroll from 'react-infinite-scroll-component';
import PropTypes from "prop-types";
import FilterAltOffOutlinedIcon from '@mui/icons-material/FilterAltOffOutlined';
import RefreshRoundedIcon from '@mui/icons-material/RefreshRounded';

const legend = [
    { color: "linear-gradient(155deg, rgb(212,209,0) 0%, rgb(255,255,189) 90%)", label: "Assigned" },
    { color: "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(4, 144, 243) 90%)", label: "Hold" },
    { color: "linear-gradient(155deg, rgb(23,166,0) 0%, rgb(196,255,189) 90%)", label: "Stocked" },
    { color: "linear-gradient(155deg, rgb(253, 253, 252) 0%, rgb(249, 27, 27) 90%)", label: "Deactivate" },
];

let FilterObj = {
    sortOrder: 'desc',
    sortColumn: 'created_on',
    tableName: ''
}

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    if (array && array.length <= 0) {
        return [];
    }
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === "desc"
        ? (a, b) => desc(a, b, orderBy)
        : (a, b) => -desc(a, b, orderBy);
}

function formatDisplayBinId(item) {
    const safeItem = item || {};
    const directBin =
        safeItem.bin_id !== undefined && safeItem.bin_id !== null
            ? safeItem.bin_id
            : safeItem.binID !== undefined && safeItem.binID !== null
                ? safeItem.binID
                : safeItem.current_bin_id !== undefined && safeItem.current_bin_id !== null
                    ? safeItem.current_bin_id
                    : safeItem.currentBinId;

    if (directBin !== undefined && directBin !== null && String(directBin).trim() !== "") {
        const token = String(directBin).trim();
        if (/^\d+$/.test(token)) return token.padStart(3, '0');
        return token.toUpperCase();
    }

    const legacy = String(safeItem.binPosition || '').trim();
    const hashMatch = legacy.match(/#\s*(\d+)/);
    if (hashMatch && hashMatch[1]) return hashMatch[1].padStart(3, '0');
    return legacy || '-';
}

class EnhancedTableHead extends React.Component {
    createSortHandler = (property, field) => event => {
        this.props.onRequestSort(event, property, field);
    };

    render() {
        const {
            order,
            orderBy,
            sortId,
            t
        } = this.props;
        const rows = [
            { id: "name", numeric: false, disablePadding: false, label: t('Task.Patient'), padding: '8px', field: 'name' },
            { id: "stock_code", numeric: false, disablePadding: false, label: t('Unplugged.SearchPopup.StockCode'), padding: '8px', field: 'stock_code' },
            { id: "pucode", numeric: false, disablePadding: false, label: t('Console.ActionPopup.PickupCode'), padding: '8px', field: 'pucode' },
            { id: "bin_position", numeric: false, disablePadding: false, label: t('Fastlan.Component.BinPosition'), padding: '8px', field: 'bin_position' },
        ];

        return (
            <TableHead>
                <TableRow
                    sx={{
                        backgroundColor: '#f8f9fa',
                        position: 'sticky',
                        top: 0,
                        zIndex: 10,
                        '& .MuiTableCell-root': {
                            backgroundColor: '#f8f9fa',
                            borderBottom: '2px solid #dee2e6'
                        }
                    }}
                >
                    <TableCell sx={{ padding: '12px 8px', border: 'none', width: '50px', textAlign: 'center' }}></TableCell>
                    {rows.map((row, idx) => {
                        // Define column widths to match body cells
                        const columnWidths = {
                            'name': '25%',
                            'stock_code': '20%',
                            'pucode': '20%',
                            'bin_position': '35%'
                        };
                        return (
                            <TableCell
                                key={row.id}
                                numeric={row.numeric}
                                padding={row.disablePadding ? "none" : "default"}
                                sortDirection={orderBy === row.id ? order : false}
                                sx={{
                                    padding: '12px 8px',
                                    color: '#495057',
                                    fontWeight: 600,
                                    fontSize: '0.875rem',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px',
                                    borderBottom: '2px solid #dee2e6',
                                    backgroundColor: '#f8f9fa',
                                    width: columnWidths[row.id] || 'auto'
                                }}
                            >
                                <Tooltip
                                    title={t("Global.Label.Filter.Sort")}
                                    placement={"right"}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === row.field && sortId === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id, row.field)}
                                        sx={{
                                            '& .MuiTableSortLabel-icon': {
                                                color: '#1976d2 !important'
                                            },
                                            '&:hover': {
                                                color: '#1976d2'
                                            }
                                        }}
                                    >
                                        {row.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
    sortId: PropTypes.string.isRequired
};
EnhancedTableHead = withTranslation()(EnhancedTableHead);

export class FastlaneProLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            binsCount: 1,
            rowsPerPagePending: 10,
            hasMore: true,
            BoxID: this.props.BoxID,
            order: "desc",
            orderBy: "created_on",
            isFiltered: false,
            status: 'All',
            fastlaneBinsMatrix: { _recentOrders: [] },
            availableBins: 0,
            yourPosition: 0,
            isRetrying: false,
            retryCount: 0,
            maxRetries: 3,
            retryMessage: '',
            showRetryError: false
        }
    }

    componentDidMount() {
        this.fetchFastlaneBinMatrix('All');
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.BoxID !== prevProps.BoxID) {
            this.setState({ BoxID: this.props.BoxID });
            this.fetchFastlaneBinMatrix('All');
        }
        if (this.props.makeAPICall !== prevProps.makeAPICall && this.props.makeAPICall) {
            this.setState({ BoxID: this.props.BoxID });
            this.reloadGrid();
        }
        
        // Only log and update when YourPosition actually changes
        const currentYourPosition = this.state.fastlaneBinsMatrix && this.state.fastlaneBinsMatrix.YourPosition;
        const prevYourPosition = prevState && prevState.fastlaneBinsMatrix && prevState.fastlaneBinsMatrix.YourPosition;
        
        if (currentYourPosition !== prevYourPosition && 
            ![undefined, 'undefined', null, 'null', '', 0].includes(currentYourPosition) && 
            !isNaN(currentYourPosition)) {
            // Store in component state only - NO localStorage
            console.log('? Fastlane - Bin position updated:', currentYourPosition);
            // Pass to parent via callback if provided
            if (this.props.onBinPositionUpdate) {
                this.props.onBinPositionUpdate(currentYourPosition);
            }
        }
    }

    handleStockCodeClick = (event, item) => {
        event && event.preventDefault();
        this.props.getPrescriptionDetails(item.bin_id, item.order_id, item.stock_code);
    }

    fetchMoreData = (type) => {
        const { fastlaneBinsMatrix } = this.state;
        const _recentOrders = fastlaneBinsMatrix._recentOrders.length && fastlaneBinsMatrix._recentOrders;
        if (type === 'pending') {
            let total = 0;
            total = _recentOrders.length;
            if (total > 0) {
                this.setState({ total: this.state.total + total, rowsPerPagePending: this.state.rowsPerPagePending + 10 });
            } else {
                this.setState({ hasMore: false });
            }
        }
    }

    handleRequestSort = (event, property, field) => {
        const { status } = this.state;
        const orderBy = property;
        let order = "desc";
        if (this.state.orderBy === orderBy) {
            order = this.state.order === "asc" ? "desc" : "asc";
        } else if (this.state.order === order) {
            order = "asc";
        } else {
            order = "desc";
        }
        this.setState({ order, orderBy, sortId: property });
        FilterObj.sortOrder = order;
        FilterObj.sortColumn = field;
        FilterObj.tableName = property === 'name' ? 'customers' : property === 'bin_position' ? 'fastlane_matrix' : '';
        this.fetchFastlaneBinMatrix(status)
    };

    handleStatusClick = (e, label) => {
        e && e.preventDefault();
        this.setState({ isFiltered: true, status: label });
        this.fetchFastlaneBinMatrix(label)
    }

    fetchFastlaneBinMatrixWithRetry = async (status, retryCount = 0) => {
        const { maxRetries } = this.state;
        const { t } = this.props;
        const boxId = (this.props && this.props.selectedBox && this.props.selectedBox.id) || 
                     (this.props && this.props.BoxID) ||
                     (this.props && this.props.box_id);
        
        console.log('FastlaneProLayout - fetchFastlaneBinMatrix attempt:', { 
            boxId, 
            retryCount,
            status 
        });
        
        if ([undefined, 'undefined', null, 'null', ''].includes(boxId)) {
            console.warn('FastlaneProLayout - No valid boxId found');
            this.setState({ 
                fastlaneBinsMatrix: { _recentOrders: [] },
                availableBins: 0,
                yourPosition: 0
            });
            return;
        }
        
        try {
            let URL = process.env.REACT_APP_BASEURL + `fastlane/matrix?boxId=${boxId}&status=${status}&tableName=${FilterObj.tableName}&sortColumn=${FilterObj.sortColumn}&sortOrder=${FilterObj.sortOrder}`;
            if(this.props.prefix === 'FASTLANEGOLIATH') {
                URL = process.env.REACT_APP_BASEURL + `fastlane-goliath/matrix?boxId=${boxId}&status=${status}&tableName=${FilterObj.tableName}&sortColumn=${FilterObj.sortColumn}&sortOrder=${FilterObj.sortOrder}`;
            }
            const response = await fetch(
                URL,
                {
                    method: 'get',
                    withCredentials: true,
                    headers: {
                        Authorization:
                            'Bearer ' +
                            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                        'Content-Type': 'application/json',
                    },
                }
            );
            
            const fastlaneBinsMatrixResponse = await response.json();
            const data = fastlaneBinsMatrixResponse && fastlaneBinsMatrixResponse.data;
            
            if (data) {
                this.setState({ 
                    fastlaneBinsMatrix: data,
                    isRetrying: false,
                    retryCount: 0,
                    retryMessage: '',
                    showRetryError: false
                });
                if (this.state.isFiltered === false) {
                    this.setState({ availableBins: data.AvailableBins, yourPosition: data.YourPosition });
                    // Store in component state only - NO localStorage
                    if (![undefined, 'undefined', null, 'null', '', 0].includes(data.YourPosition)) {
                        console.log('? Fastlane - Bin position available:', data.YourPosition);
                        // Pass to parent via callback if provided
                        if (this.props.onBinPositionUpdate) {
                            this.props.onBinPositionUpdate(data.YourPosition);
                        }
                    }
                }
            } else {
                console.error('No data received from Fastlane matrix API');
                return null;
            }
        } catch (error) {
            console.error(`Fastlane matrix fetch attempt ${retryCount + 1} failed:`, error);
            
            if (retryCount < maxRetries - 1) {
                this.setState({
                    retryCount: retryCount + 1,
                    retryMessage: t('Assign.Fastlane.RetryingAttempt', { 
                        attempt: retryCount + 2, 
                        total: maxRetries 
                    })
                });
                
                await new Promise(resolve => setTimeout(resolve, 1000));
                return await this.fetchFastlaneBinMatrixWithRetry(status, retryCount + 1);
            } else {
                this.setState({ 
                    isRetrying: false,
                    retryCount: 0,
                    retryMessage: '',
                    showRetryError: true,
                    fastlaneBinsMatrix: { _recentOrders: [] },
                    availableBins: 0,
                    yourPosition: 0
                });
            }
        }
    }

    fetchFastlaneBinMatrix = (status) => {
        const { t } = this.props;
        const isGoliath = this.props.prefix === 'FASTLANEGOLIATH';
        this.setState({ 
            isRetrying: isGoliath ? false : true,
            retryMessage: isGoliath
                ? ''
                : t('Assign.Fastlane.FetchingAttempt', {
                    attempt: 1,
                    total: this.state.maxRetries
                })
        });
        
        this.fetchFastlaneBinMatrixWithRetry(status, 0);
    }

    handleRetryErrorOkay = () => {
        this.setState({ 
            showRetryError: false,
            isRetrying: true,
            retryMessage: this.props.t('Assign.Fastlane.FetchingAttempt', { 
                attempt: 1, 
                total: this.state.maxRetries 
            }),
            retryCount: 0
        });
        this.fetchFastlaneBinMatrixWithRetry(this.state.status || 'All', 0);
    }

    clearFilters = () => {
        FilterObj.sortOrder = 'desc';
        FilterObj.sortColumn = 'created_on';
        FilterObj.tableName = '';
        this.fetchFastlaneBinMatrix('All');
        this.setState({ isFiltered: false, status: 'All' });
    }

    reloadGrid = () => {
        FilterObj.sortOrder = 'desc';
        FilterObj.sortColumn = 'created_on';
        FilterObj.tableName = '';
        this.setState({ isFiltered: false })
        this.fetchFastlaneBinMatrix('All');
    }

    render() {
        const { t, isViewPermissionAllowed } = this.props;
        const { fastlaneBinsMatrix, isFiltered, availableBins, yourPosition, status } = this.state;
        const isGoliath = this.props.prefix === 'FASTLANEGOLIATH';
        const _recentOrders = fastlaneBinsMatrix && fastlaneBinsMatrix._recentOrders;
        // Enable clear filter button only when a filter is applied (regardless of results)
        const isFilterDisabled = !isFiltered;
        
        return (
            <Box
                component='div'
                sx={{
                    width: '100%',
                    textAlign: 'center',
                    mt: '2%',
                    px: 2,
                }}
            >
                {/* Modern Card View for Available and Your Position */}
                <Grid container spacing={0.5} sx={{ mb: 0.5 }}>
                    <Grid item xs={12} sm={isGoliath ? 12 : 6}>
                        <Card
                            sx={{
                                background: 'linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)',
                                color: 'white',
                                borderRadius: '6px',
                                boxShadow: '0 1px 4px rgba(25, 118, 210, 0.3)',
                                transition: 'transform 0.2s, box-shadow 0.2s',
                                maxHeight: '60px',
                                '&:hover': {
                                    transform: 'translateY(-1px)',
                                    boxShadow: '0 2px 6px rgba(25, 118, 210, 0.4)',
                                },
                                '& .MuiCardContent-root': {
                                    padding: '0.5rem !important',
                                    '&:last-child': {
                                        paddingBottom: '0.5rem'
                                    }
                                }
                            }}
                        >
                            <CardContent sx={{ py: 0.5, px: 1, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontSize: '0.7rem',
                                        opacity: 0.9,
                                        fontWeight: 500,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.3px',
                                        lineHeight: 1.2
                                    }}
                                >
                                    {t('API.DeviceType.Available')}
                                </Typography>
                                <Typography
                                    variant="h4"
                                    sx={{
                                        fontSize: '1.1rem',
                                        fontWeight: 700,
                                        lineHeight: 1.2
                                    }}
                                >
                                    {availableBins}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    {!isGoliath && (
                    <Grid item xs={12} sm={6}>
                        <Card
                            sx={{
                                background: 'linear-gradient(135deg, #1565c0 0%, #42a5f5 100%)',
                                color: 'white',
                                borderRadius: '6px',
                                boxShadow: '0 1px 4px rgba(21, 101, 192, 0.3)',
                                transition: 'transform 0.2s, box-shadow 0.2s',
                                maxHeight: '60px',
                                '&:hover': {
                                    transform: 'translateY(-1px)',
                                    boxShadow: '0 2px 6px rgba(21, 101, 192, 0.4)',
                                },
                                '& .MuiCardContent-root': {
                                    padding: '0.5rem !important',
                                    '&:last-child': {
                                        paddingBottom: '0.5rem'
                                    }
                                }
                            }}
                        >
                            <CardContent sx={{ py: 0.5, px: 1, display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontSize: '0.7rem',
                                        opacity: 0.9,
                                        fontWeight: 500,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.3px',
                                        lineHeight: 1.2
                                    }}
                                >
                                    {t('Fastlan.Component.YourPosition')}
                                </Typography>
                                <Typography
                                    variant="h4"
                                    sx={{
                                        fontSize: '1.1rem',
                                        fontWeight: 700,
                                        lineHeight: 1.2
                                    }}
                                >
                                    {yourPosition || '�'}
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                    )}
                </Grid>

                {/* Modern Recent Orders Section */}
                <Card
                    sx={{
                        borderRadius: '12px',
                        boxShadow: '0 2px 12px rgba(0, 0, 0, 0.08)',
                        overflow: 'hidden'
                    }}
                >
                    <Box
                        sx={{
                            p: 2,
                            backgroundColor: '#f8f9fa',
                            borderBottom: '1px solid #e9ecef',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <Typography
                            variant="h6"
                            sx={{
                                color: '#212529',
                                fontSize: '1.25rem',
                                fontWeight: 600,
                                m: 0
                            }}
                        >
                            {this.props.prefix === 'FASTLANEGOLIATH' ? t('Fastlan.Goliath.Component.Title') : t('Fastlan.Component.RecentOrdersTitle')}
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 1 }}>
                            <Tooltip key="reload-grid" title={t("Reload")}>
                                <IconButton
                                    onClick={() => this.reloadGrid()}
                                    sx={{
                                        backgroundColor: 'white',
                                        '&:hover': {
                                            backgroundColor: '#e9ecef',
                                        }
                                    }}
                                >
                                    <RefreshRoundedIcon />
                                </IconButton>
                            </Tooltip>
                            <Tooltip key="clear-filters" title={t("Report.Assign.ClearFiltersTooltip")}>
                                <IconButton
                                    disabled={isFilterDisabled}
                                    onClick={() => this.clearFilters()}
                                    sx={{
                                        backgroundColor: 'white',
                                        '&:hover': {
                                            backgroundColor: '#e9ecef',
                                        },
                                        '&.Mui-disabled': {
                                            backgroundColor: '#f8f9fa',
                                            opacity: 0.5
                                        },
                                        color: isFiltered ? '#1976d2' : 'inherit'
                                    }}
                                >
                                    <FilterAltOffOutlinedIcon />
                                </IconButton>
                            </Tooltip>
                        </Box>
                    </Box>
                    <Box sx={{ p: 2 }}>
                        {/* Fixed Header Table */}
                        <Box sx={{ position: 'relative', zIndex: 10, backgroundColor: '#f8f9fa' }}>
                            <Table
                                sx={{
                                    tableLayout: 'fixed',
                                    width: '100%',
                                    '& .MuiTableCell-root': {
                                        borderBottom: '2px solid #dee2e6',
                                    }
                                }}
                            >
                                <EnhancedTableHead
                                    order={FilterObj.sortOrder}
                                    orderBy={FilterObj.sortColumn}
                                    sortId={this.state.sortId}
                                    onRequestSort={this.handleRequestSort}
                                />
                            </Table>
                        </Box>
                        {/* Scrollable Body */}
                        <Box
                            sx={{
                                position: 'relative',
                                height: '365px',
                                overflow: 'auto'
                            }}
                            id="fastlane-scrollable-container"
                        >
                            <InfiniteScroll
                                dataLength={this.state.rowsPerPagePending}
                                next={() => this.fetchMoreData('pending')}
                                hasMore={this.state.hasMore}
                                scrollableTarget="fastlane-scrollable-container"
                                endMessage={
                                    <Box sx={{ textAlign: 'center', py: 2 }}>
                                        <Typography variant="body2" sx={{ fontWeight: 600, color: '#6c757d' }}>
                                            {t("Console.YouHaveSeenIt")}
                                        </Typography>
                                    </Box>
                                }>
                                <Table
                                    sx={{
                                        tableLayout: 'fixed',
                                        width: '100%',
                                        '& .MuiTableCell-root': {
                                            borderBottom: '1px solid #e9ecef',
                                        }
                                    }}
                                >
                                    <TableBody>
                                        {_recentOrders ? stableSort(_recentOrders, getSorting(FilterObj.sortOrder, FilterObj.sortColumn)).map((item, index) => {
                                            return (
                                                <TableRow
                                                    key={index}
                                                    sx={{
                                                        '&:hover': {
                                                            backgroundColor: '#f8f9fa',
                                                            cursor: 'pointer'
                                                        },
                                                        transition: 'background-color 0.2s'
                                                    }}
                                                >
                                                    <TableCell sx={{ padding: '12px 8px', border: 'none', width: '50px', textAlign: 'center' }}>
                                                        <Tooltip key={index} title={item && item.rowProperties && item.rowProperties.type}>
                                                            <Box
                                                                component="span"
                                                                sx={{
                                                                    background: item && item.rowProperties && item.rowProperties.bgColor,
                                                                    border: '2px solid #dee2e6',
                                                                    borderRadius: '50%',
                                                                    height: '24px',
                                                                    width: '24px',
                                                                    display: 'inline-block',
                                                                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                }}
                                                            />
                                                        </Tooltip>
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '12px 8px', fontWeight: 500, color: '#212529', width: '25%' }}>
                                                        {item.name}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '12px 8px', width: '20%' }}>
                                                        {isViewPermissionAllowed ? (
                                                            <Typography
                                                                component="a"
                                                                href=''
                                                                onClick={(event) => this.handleStockCodeClick(event, item)}
                                                                sx={{
                                                                    fontWeight: 600,
                                                                    textDecoration: 'none',
                                                                    color: '#1976d2',
                                                                    fontSize: '0.95rem',
                                                                    '&:hover': {
                                                                        textDecoration: 'underline',
                                                                        color: '#1565c0'
                                                                    }
                                                                }}
                                                            >
                                                                {item.stock_code}
                                                            </Typography>
                                                        ) : (
                                                            <Typography sx={{ color: '#495057' }}>
                                                                {item.stock_code}
                                                            </Typography>
                                                        )}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '12px 8px', color: '#495057', fontFamily: 'monospace', fontSize: '0.9rem', width: '20%' }}>
                                                        {item.pucode}
                                                    </TableCell>
                                                    <TableCell sx={{ padding: '12px 8px', color: '#495057', fontWeight: 500, width: '35%' }}>
                                                        {formatDisplayBinId(item)}
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        }) :
                                            <TableRow>
                                                <TableCell colSpan={5} sx={{ borderBottom: 'none', textAlign: 'center', py: 4 }}>
                                                    <Typography variant="body1" sx={{ color: '#6c757d' }}>
                                                        {t("Unplugged.NoDataFound")}
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>}
                                    </TableBody>
                                </Table>
                            </InfiniteScroll>
                            {/* Sticky Legend Filters at Bottom */}
                            <Box
                                sx={{
                                    position: 'sticky',
                                    bottom: 0,
                                    left: 0,
                                    right: 0,
                                    p: 1,
                                    backgroundColor: '#f8f9fa',
                                    borderTop: '1px solid #e9ecef',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    zIndex: 10,
                                    boxShadow: '0 -2px 8px rgba(0,0,0,0.1)',
                                    overflowX: 'auto',
                                    overflowY: 'hidden',
                                    '&::-webkit-scrollbar': {
                                        height: '4px'
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: '#f1f1f1'
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: '#888',
                                        borderRadius: '2px'
                                    }
                                }}
                            >
                                <Box sx={{ display: 'flex', flexDirection: 'row', gap: 0.75, justifyContent: 'center', alignItems: 'center', flexWrap: 'nowrap', minWidth: 'fit-content' }}>
                                    {legend.map((value, idx) => {
                                        const isActive = isFiltered && status === value.label;
                                        return (
                                            <Button
                                                key={idx}
                                                onClick={(e) => this.handleStatusClick(e, value.label)}
                                                variant="outlined"
                                                size="small"
                                                sx={{
                                                    minWidth: 'auto',
                                                    padding: '4px 12px',
                                                    borderRadius: '16px',
                                                    backgroundColor: isActive ? '#e3f2fd' : 'white',
                                                    borderColor: isActive ? '#1976d2' : '#dee2e6',
                                                    borderWidth: isActive ? '2px' : '1px',
                                                    textTransform: 'none',
                                                    fontSize: '0.8rem',
                                                    fontWeight: isActive ? 600 : 500,
                                                    color: isActive ? '#1976d2' : '#495057',
                                                    whiteSpace: 'nowrap',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '6px',
                                                    flexShrink: 0,
                                                    transition: 'all 0.2s',
                                                    boxShadow: isActive ? '0 2px 8px rgba(25, 118, 210, 0.3)' : 'none',
                                                    '&:hover': {
                                                        backgroundColor: isActive ? '#bbdefb' : '#e9ecef',
                                                        borderColor: isActive ? '#1976d2' : '#adb5bd',
                                                        transform: 'translateY(-1px)',
                                                        boxShadow: isActive ? '0 4px 12px rgba(25, 118, 210, 0.4)' : '0 2px 6px rgba(0,0,0,0.1)'
                                                    }
                                                }}
                                            >
                                                <Box
                                                    component="span"
                                                    sx={{
                                                        background: value.color,
                                                        height: '14px',
                                                        width: '14px',
                                                        border: '2px solid #dee2e6',
                                                        borderRadius: '50%',
                                                        display: 'inline-block',
                                                        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                                                        flexShrink: 0
                                                    }}
                                                />
                                                <Box component="span" sx={{ whiteSpace: 'nowrap' }}>
                                                    {value.label}
                                                </Box>
                                            </Button>
                                        );
                                    })}
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                </Card>
                
                <Dialog
                    open={!isGoliath && (this.state.isRetrying || false)}
                    aria-labelledby='fastlane-retry-dialog-title'
                    aria-describedby='fastlane-retry-dialog-description'
                    disableEscapeKeyDown
                    onClose={(event, reason) => {
                        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                            return false;
                        }
                    }}
                    PaperProps={{
                        style: { 
                            minWidth: '400px'
                        }
                    }}
                    BackdropProps={{
                        style: {
                            backgroundColor: 'rgba(0, 0, 0, 0.7)'
                        }
                    }}
                >
                    <DialogTitle id='fastlane-retry-dialog-title' sx={{ textAlign: 'center', color: '#1976d2' }}>
                        {t('Assign.Fastlane.RetryDialogTitle')}
                    </DialogTitle>
                    <DialogContent sx={{ textAlign: 'center', pb: 3, pt: 2 }}>
                        <Box component='div' sx={{ mb: 2 }}>
                            <img
                                src={spinner}
                                alt='loading'
                                style={{ width: '50px', height: '50px' }}
                            />
                        </Box>
                        <DialogContentText id='fastlane-retry-dialog-description' sx={{ fontSize: '1rem', fontWeight: 600, color: '#000' }}>
                            {this.state.retryMessage}
                        </DialogContentText>
                        <DialogContentText sx={{ mt: 1, fontSize: '0.875rem', color: '#666' }}>
                            {t('Assign.Fastlane.RetryMessage')}
                        </DialogContentText>
                    </DialogContent>
                </Dialog>

                <Dialog
                    open={!isGoliath && (this.state.showRetryError || false)}
                    aria-labelledby='fastlane-error-dialog-title'
                    aria-describedby='fastlane-error-dialog-description'
                    disableEscapeKeyDown
                    onClose={(event, reason) => {
                        if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
                            return false;
                        }
                    }}
                >
                    <DialogTitle id='fastlane-error-dialog-title' sx={{ color: '#d32f2f' }}>
                        {t('Assign.Fastlane.ErrorDialogTitle')}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id='fastlane-error-dialog-description'>
                            {t('Assign.Fastlane.ErrorMessage')}
                        </DialogContentText>
                        <DialogContentText sx={{ mt: 2, fontWeight: 500 }}>
                            {t('Assign.Fastlane.ErrorQuestion')}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.handleRetryErrorOkay}
                            color='primary'
                            autoFocus
                        >
                            {t('Assign.Fastlane.TryAgainButton')}
                        </Button>
                        <Button
                            onClick={() => this.setState({ showRetryError: false })}
                            color='primary'
                        >
                            {t('Assign.CancelButton')}
                        </Button>
                    </DialogActions>
                </Dialog>
            </Box>
        )
    }
}

export default withStyles(styles)(withTranslation()(FastlaneProLayout));


// WEBPACK FOOTER //
// ./src/components/assign-prescriptions/fastlane-pro.js